export class NightFilter extends PIXI.Filter<any> {
    private static readonly FRAG: string = `
        varying vec2 vTextureCoord;
        uniform sampler2D uSampler;
        uniform sampler2D uRamp;

        void main() {
            vec4 color = texture2D(uSampler, vTextureCoord);
            float brightness = (0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b);
            vec4 ramp = texture2D(uRamp, vec2(brightness, 0));
            color.r = mix(color.r, ramp.r, 0.6);
            color.g = mix(color.g, ramp.g, 0.6);
            color.b = mix(color.b, ramp.b, 0.6);
            gl_FragColor = color;
        }
    `;

    constructor(pRamp: PIXI.Texture) {
        super(undefined, NightFilter.FRAG);
        this.uniforms.uRamp = pRamp;
    }
}
